import { gql } from "@apollo/client";

export const CREATE_ASSET_CATEGORY_MUTATION = gql`
    mutation CreateAssetCategory($input: CreateAssetCategoryInput!) {
        createAssetCategory(input: $input) {
            createdAt
            default
            deletedAt
            description
            hidden
            iconColor
            iconName
            iconType
            id
            name
            updatedAt
        }
    }
`;

// Update Asset Category Mutation

export const UPDATE_ASSET_CATEGORY_MUTATION = gql`
    mutation UpdateAssetCategory($input: UpdateAssetCategoryInput!) {
        updateAssetCategory(input: $input) {
            createdAt
            default
            deletedAt
            description
            hidden
            iconColor
            iconName
            iconType
            id
            name
            updatedAt
        }
    }
`;

// Delete Asset Category Mutation

export const DELETE_ASSET_CATEGORY_MUTATION = gql`
    mutation RemoveAssetCategory($id: ID!) {
        removeAssetCategory(id: $id)
    }
`;

// Create Manufacturer Mutation

export const CREATE_MANUFACTURER_MUTATION = gql`
    mutation CreateMasterManufacturer($input: CreateMasterManufacturerInput!) {
        createMasterManufacturer(input: $input) {
            id
            name
            email
            company_name
            website
            address
            phone_number
            country_code
            contact_person
            created_at
            updated_at
        }
    }
`;

// Update Manufacturer Mutation

export const UPDATE_MANUFACTURER_MUTATION = gql`
    mutation UpdateMasterManufacturer($input: UpdateMasterManufacturerInput!) {
        updateMasterManufacturer(input: $input) {
            id
            name
            email
            company_name
            website
            address
            phone_number
            country_code
            contact_person
            created_at
            updated_at
        }
    }
`;

// Delete Manufacturer Mutation

export const DELETE_MANUFACTURER_MUTATION = gql`
    mutation DeleteMasterManufacturer($input: DeleteMasterManufacturerInput!) {
        deleteMasterManufacturer(input: $input) {
            success
            message
        }
    }
`;

// Create Vendor Mutation

export const CREATE_VENDOR_MUTATION = gql`
    mutation CreateMasterVendor($input: CreateMasterVendorInput!) {
        createMasterVendor(input: $input) {
            id
            company_name
            website
            email
            name
            phone_number
            country_code
            vendor_type
            can_login
            invited_by_user
            created_at
            updated_at
        }
    }
`;

// Update Vendor Mutation

export const UPDATE_VENDOR_MUTATION = gql`
    mutation UpdateMasterVendor($input: UpdateMasterVendorInput!) {
        updateMasterVendor(input: $input) {
            id
            company_name
            website
            email
            name
            phone_number
            country_code
            vendor_type
            can_login
            invited_by_user
            created_at
            updated_at
        }
    }
`;

// Delete Vendor Mutation

export const DELETE_VENDOR_MUTATION = gql`
    mutation DeleteMasterVendor($id: ID!) {
        deleteMasterVendor(input: { id: $id }) {
            success
            message
        }
    }
`;

// Create Work Order Stage Mutation

export const CREATE_WORK_ORDER_STAGE_MUTATION = gql`
   mutation CreateWorkOrderStage($input: CreateMasterWorkOrderStageInput!) {
  createMasterWorkOrderStage(input: $input) {
    id
    name
    color_code
    display_order
    created_at
    updated_at
  }
}
`;

// Update Work Order Stage Mutation

export const UPDATE_WORK_ORDER_STAGE_MUTATION = gql`
   mutation UpdateWorkOrderStage($input: UpdateMasterWorkOrderStageInput!) {
  updateMasterWorkOrderStage(input: $input) {
    id
    name
    color_code
    display_order
    created_at
    updated_at
  }
}
`;

// Delete Work Order Stage Mutation

export const DELETE_WORK_ORDER_STAGE_MUTATION = gql`
   mutation DeleteWorkOrderStage($input: DeleteMasterDataInput!) {
  deleteMasterWorkOrderStage(input: $input) {
    success
    message
  }
}
`;


// Create Work Order Type Mutation

export const CREATE_WORK_ORDER_TYPE_MUTATION = gql`
    mutation CreateMasterWorkOrderType($input: CreateMasterWorkOrderTypeInput!) {
        createMasterWorkOrderType(input: $input) {
            id
            name
            created_at
            updated_at
        }
    }
`;

// Update Work Order Type Mutation

export const UPDATE_WORK_ORDER_TYPE_MUTATION = gql`
    mutation UpdateMasterWorkOrderType($input: UpdateMasterWorkOrderTypeInput!) {
        updateMasterWorkOrderType(input: $input) {
            id
            name
            created_at
            updated_at
        }
    }
`;

// Delete Work Order Type Mutation

export const DELETE_WORK_ORDER_TYPE_MUTATION = gql`mutation DeleteWorkOrderType($input: DeleteMasterDataInput!) {
  deleteMasterWorkOrderType(input: $input) {
    success
    message
  }
}
`;

// Create Service Category Mutation

export const CREATE_SERVICE_CATEGORY_MUTATION = gql`
    mutation CreateMasterWorkOrderServiceCategory($input: CreateMasterWorkOrderServiceCategoryInput!) {
        createMasterWorkOrderServiceCategory(input: $input) {
            id
            name
            created_at
            updated_at
        }
    }
`;

// Update Service Category Mutation

export const UPDATE_SERVICE_CATEGORY_MUTATION = gql`
    mutation UpdateMasterWorkOrderServiceCategory($input: UpdateMasterWorkOrderServiceCategoryInput!) {
        updateMasterWorkOrderServiceCategory(input: $input) {
            id
            name
            created_at
            updated_at
        }
    }
`;

// Delete Service Category Mutation

export const DELETE_SERVICE_CATEGORY_MUTATION = gql`
   mutation DeleteServiceCategory($input: DeleteMasterDataInput!) {
  deleteMasterWorkOrderServiceCategory(input: $input) {
    success
    message
  }
}
`;

// Create Assignment Mutation

export const CREATE_ASSIGNMENT_MUTATION = gql`
    mutation CreateMasterWorkOrderAssignmentType($input: CreateMasterWorkOrderAssignmentTypeInput!) {
        createMasterWorkOrderAssignmentType(input: $input) {
            id
            name
            created_at
            updated_at
        }
    }
`;

// Update Assignment Mutation

export const UPDATE_ASSIGNMENT_MUTATION = gql`
    mutation UpdateMasterWorkOrderAssignmentType($input: UpdateMasterWorkOrderAssignmentTypeInput!) {
        updateMasterWorkOrderAssignmentType(input: $input) {
            id
            name
            created_at
            updated_at
        }
    }
`;

// Delete Assignment Mutation

export const DELETE_ASSIGNMENT_MUTATION = gql`
    mutation DeleteAssignmentType($input: DeleteMasterDataInput!) {
  deleteMasterWorkOrderAssignmentType(input: $input) {
    success
    message
  }
}
`;

// Create Asset Type Mutation

export const CREATE_ASSET_TYPE_MUTATION = gql`
    mutation CreateAssetType($input: CreateAssetTypeInput!) {
        createAssetType(input: $input) {
            assetCategoryId
            createdAt
            deletedAt
            description
            hidden
            iconColor
            iconName
            iconType
            id
            name
            specialAssetField
            updatedAt
        }
    }
`;

// Update Asset Type Mutation

export const UPDATE_ASSET_TYPE_MUTATION = gql`
    mutation UpdateAssetType($input: UpdateAssetTypeInput!) {
        updateAssetType(input: $input) {
            assetCategoryId
            createdAt
            deletedAt
            description
            hidden
            iconColor
            iconName
            iconType
            id
            name
            specialAssetField
            updatedAt
        }
    }
`;

// Delete Asset Type Mutation

export const DELETE_ASSET_TYPE_MUTATION = gql`
    mutation RemoveAssetType($id: ID!) {
        removeAssetType(id: $id)
    }
`;

export const CREATE_PRODUCT_MUTATION = gql`
  mutation CreateProduct($input: CreateProductInput!) {
    createProduct(input: $input) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      isActive
    }
  }
`;

export const UPDATE_PRODUCT_MUTATION = gql`
  mutation UpdateProduct($input: UpdateProductInput!) {
    updateProduct(input: $input) {
      id
      parentId
      categoryId
      typeId
      manufacturerId
      successorId
      predecessorId
      name
      make
      model
      serialNumber
      dataSheets
      lifespan
      rating
      specifications
      images
      description
      lifecycleStatus
      manufacturerStatus
      isActive
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const DELETE_PRODUCT_MUTATION = gql`
  mutation DeleteProduct($input: DeleteProductInput!) {
    deleteProduct(input: $input)
  }
`;

// Create Ticket Comment Mutation
